
import React, { useState, useEffect } from 'react';
import Plaintext from './plaintext';
import Text from './text';
import Helpers from 'utils/helpers';

export default function TextInputNumberIntegerWrapper(props) {
  if (props.plaintext || props.readOnly || props.readonly || props.disabled) {
    return (
      <Plaintext style={props.style}>
        {Helpers.Object.exists(props.value) ? props.value : props.defaultValue}
      </Plaintext>
    );
  }
  else {
    return <TextInputNumberInteger {...props} />;
  }
}

function TextInputNumberInteger(props) {
  const { onChange, onValueChange, onBlur, deferChange, value, defaultValue, min, max, ...childProps } = props;
  const minValue = parseInt(min) || 0;
  const maxValue = parseInt(max) || 2147483647;

  const [displayValue, setDisplayValue] = useState('');

  useEffect(() => {
    setDisplayValue(value || defaultValue);
  }, [value, defaultValue]);

  const handleChange = (event) => {
    const newValue = event.target.value.replace(/\D/g, '');
    if (newValue !== displayValue) {
      setDisplayValue(newValue);
      if (onChange) {
        const syntheticEvent = { ...event };
        syntheticEvent.target.value = newValue;
        onChange(syntheticEvent);
      }
      if (onValueChange && !deferChange) {
        onValueChange(newValue);
      }
    }
  };

  const handleBlur = (event) => {
    const value = (!displayValue || displayValue.length === 0) ? 0 : parseInt(displayValue);
    let newValue = value;
    if (value < minValue) {
      newValue = minValue;
    }
    else if (value > maxValue) {
      newValue = maxValue;
    }

    if (newValue !== value) {
      setDisplayValue(newValue);
      if (onChange) {
        const syntheticEvent = {
          target: {
            value: newValue,
          },
        };
        onChange(syntheticEvent);
      }
      if (onValueChange) {
        onValueChange(newValue);
      }
    }
    if (onValueChange && deferChange) {
      onValueChange(newValue);
    }
    if (onBlur) {
      onBlur(event);
    }
  };

  return (
    <Text
      {...childProps}
      value={displayValue || ''}
      onChange={handleChange}
      onBlur={handleBlur}
      inputMode='numeric'
      pattern='[0-9]*'
      validation='number'
    />
  );
}